import { c as _c } from "react/compiler-runtime";
import { useFeatureFlag } from '@newfront-insurance/admin-ui';
import type { Route } from '@newfront-insurance/next-router-provider';
import { useRouter } from '@newfront-insurance/next-router-provider';
import { useProvider } from '@newfront-insurance/react-provision';
import type { ReactNode, JSX } from 'react';
import { AccountMenu } from './components/account-menu';
import { AppBadge } from './components/app-badge';
import { AppSwitcherButton } from './components/app-switcher';
import { ReportBugButton } from './components/bug-button';
import { SearchButton } from './components/search-button';
import { SnowfallToggle } from './snowfall-toggle';
import { ThemeModeToggle } from './theme-toggle';
import { LayoutConfigProvider } from '../../config';
interface Props {
  disableHomeLink?: boolean;
  homeRoute?: Route;
  leftToolbar?: ReactNode;
  rightToolbar?: ReactNode;
  showDarkModeToggle?: boolean;
  snowfallProvider?: {
    isSnowfallEnabled: boolean;
    toggleSnowfall: () => void;
  };
}
export function HomeLink(t0) {
  const $ = _c(10);
  const {
    homeRoute,
    disableHomeLink,
    isShowingDarkSidebar
  } = t0;
  const {
    createLink
  } = useRouter();
  const {
    currentApp
  } = useProvider(LayoutConfigProvider);
  let t1;
  if ($[0] !== homeRoute) {
    t1 = homeRoute ?? {
      pathname: "/"
    };
    $[0] = homeRoute;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== createLink || $[3] !== t1) {
    t2 = createLink(t1);
    $[2] = createLink;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const homeLink = t2;
  let t3;
  if ($[5] !== currentApp || $[6] !== disableHomeLink || $[7] !== homeLink || $[8] !== isShowingDarkSidebar) {
    t3 = <div>{disableHomeLink ? <AppBadge type={currentApp} textSize="large" iconSize={40} isShowingDarkSidebar={isShowingDarkSidebar} /> : <a className={`-m-2 block rounded-xs p-2 no-underline ${isShowingDarkSidebar ? "hover:bg-steel-500" : "hover:bg-steel-100"}`} href={homeLink.href} onClick={homeLink.onClick} title="Go back home"><AppBadge type={currentApp} textSize="large" iconSize={40} isShowingDarkSidebar={isShowingDarkSidebar} /></a>}</div>;
    $[5] = currentApp;
    $[6] = disableHomeLink;
    $[7] = homeLink;
    $[8] = isShowingDarkSidebar;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export function AppRightMenu(t0) {
  const $ = _c(20);
  const {
    showDarkModeToggle,
    disableReportBug,
    disableAppSwitcher,
    disableSearch,
    disableAccountMenu,
    snowfallProvider
  } = t0;
  const isSnowfallFeatureFlagEnabled = useFeatureFlag("snowfall", false);
  let t1;
  if ($[0] !== isSnowfallFeatureFlagEnabled || $[1] !== snowfallProvider) {
    t1 = isSnowfallFeatureFlagEnabled && snowfallProvider && <SnowfallToggle snowfallProvider={snowfallProvider} />;
    $[0] = isSnowfallFeatureFlagEnabled;
    $[1] = snowfallProvider;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== showDarkModeToggle) {
    t2 = showDarkModeToggle && <ThemeModeToggle />;
    $[3] = showDarkModeToggle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== disableReportBug) {
    t3 = !disableReportBug && <ReportBugButton />;
    $[5] = disableReportBug;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== disableSearch) {
    t4 = !disableSearch && <SearchButton />;
    $[7] = disableSearch;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== disableAppSwitcher) {
    t5 = !disableAppSwitcher && <AppSwitcherButton />;
    $[9] = disableAppSwitcher;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== disableAccountMenu) {
    t6 = !disableAccountMenu && <AccountMenu />;
    $[11] = disableAccountMenu;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <div className="flex flex-row items-center gap-1.5">{t1}{t2}{t3}{t4}{t5}{t6}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
export function AppHeader(t0) {
  const $ = _c(15);
  const {
    disableHomeLink,
    homeRoute,
    leftToolbar,
    rightToolbar,
    showDarkModeToggle,
    snowfallProvider
  } = t0;
  let t1;
  if ($[0] !== disableHomeLink || $[1] !== homeRoute) {
    t1 = <HomeLink homeRoute={homeRoute} disableHomeLink={disableHomeLink} />;
    $[0] = disableHomeLink;
    $[1] = homeRoute;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== leftToolbar || $[4] !== t1) {
    t2 = <div className="flex items-center gap-4">{t1}{leftToolbar}</div>;
    $[3] = leftToolbar;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== showDarkModeToggle || $[7] !== snowfallProvider) {
    t3 = <AppRightMenu showDarkModeToggle={showDarkModeToggle} snowfallProvider={snowfallProvider} />;
    $[6] = showDarkModeToggle;
    $[7] = snowfallProvider;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== rightToolbar || $[10] !== t3) {
    t4 = <div className="flex flex-row items-center gap-1.5">{rightToolbar}{t3}</div>;
    $[9] = rightToolbar;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = <div className="relative z-10 box-border flex h-[72px] flex-row items-center justify-between border-b-2 border-[#BEC7D050] bg-white px-6 py-0">{t2}{t4}</div>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}